import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import TagManager from "react-gtm-module";
import { store } from "./store/store";
import { Provider } from "react-redux";

const tagManagerArgs = {
  gtmId: "GTM-WFXSCT7K", // Replace with your GTM ID
};

TagManager.initialize(tagManagerArgs);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Router>
        <Provider store={store}>
        <App />
        </Provider>
      </Router>
    </HelmetProvider>
  </React.StrictMode>
);

